import { CommonModule } from '@angular/common';
import { Component, computed, input, output, TemplateRef, viewChild } from '@angular/core';

import { IPaginationResponseResolver, ISoftDeletablePaginationParameters } from '../../../data-access';
import { IActionConfig, IActionExecutedEvent, IDialogConfig, ITableConfig } from '../../../ui';
import { ISoftDeltableAuditableEntity } from '../../../primitives';
import { SoftDeletableEntitiesComponent } from '../soft-deletable-entities';
import { DateFormatPipe } from '../../../../../trash/shared/pipes/date-format.pipe';

@Component({
  selector: 'app-soft-deletable-auditable-entities',
  standalone: true,
  providers: [],
  imports: [CommonModule, SoftDeletableEntitiesComponent, DateFormatPipe],
  templateUrl: './soft-deletable-auditable-entities.component.html',
  styleUrls: ['./soft-deletable-auditable-entities.component.scss']
})
export class SoftDeletableAuditableEntitiesComponent<
  TEntity extends ISoftDeltableAuditableEntity,
  TPaginationParameters extends ISoftDeletablePaginationParameters
> {
  tableRowTemplate = viewChild.required<TemplateRef<{ $implicit: TEntity }>>('tableRowTemplate');
  paginationResponseResolver = input.required<IPaginationResponseResolver<TEntity, TPaginationParameters>>();
  defaultPaginationParameters = input.required<TPaginationParameters>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  tableConfig = input<ITableConfig>();
  actionExecuted = output<IActionExecutedEvent<TEntity>>();

  finalTableConfig = computed(() => ({
    fields: [...(this.tableConfig()?.fields ?? []), { name: 'createdOnUtc', displayName: 'GENERAL.CREATE_ON' }],
    template: this.tableRowTemplate()
  }));

  onActionExecuted(event: unknown) {
    this.actionExecuted.emit(event as IActionExecutedEvent<TEntity>);
  }
}
